import { H5 } from '@snsw/react-component-library';
import { FeeRow } from 'components/FeeSummary/FeeRow';
import React from 'react';
import { Fee } from './types';

interface Props {
  values: Fee[] | Fee[][];
  netFeeAmount: number;
}

const FeeRowsWithSubtotal = ({ values }: { values: Fee[] }) => {
  const subtotal = values.reduce((acc, i) => acc + i.value, 0);

  return (
    <>
      {values.map((lineItem) => (
        <FeeRow key={lineItem.feeName} {...lineItem} />
      ))}

      <FeeRow isTitleContainer value={subtotal} feeName={<H5>Subtotal</H5>} />
    </>
  );
};

export const FeeLineItems = ({ values, netFeeAmount }: Props) => {
  return (
    <>
      {values?.map((lineItem) => (
        <>
          {Array.isArray(lineItem) && <FeeRowsWithSubtotal values={lineItem} />}
          {!Array.isArray(lineItem) && <FeeRow key={lineItem.feeName} {...lineItem} />}
        </>
      ))}

      <FeeRow isSummary value={netFeeAmount} feeName={<H5>Total due</H5>} />
    </>
  );
};
